import { EntityState } from '@reduxjs/toolkit'
import { normalizeFilters } from '@user/components/Filters'
import { Draft } from 'immer'
import { IOpportunity, OpportunityPageState, OpportunityFilterSet } from '.'
import { defaultOrderBy, sortOptionArray } from './filters'
import { SOLD_SERVICE_STATUS } from '@sales-center/common'

export const setOrderBy = (
  state: Draft<EntityState<IOpportunity> & OpportunityPageState>,
  orderBy: string,
) => {
  if (state.mode === 'card' && !sortOptionArray.includes(orderBy))
    state.filterSet.orderBy = defaultOrderBy
}

export const updateFilterState = (
  state: Draft<EntityState<IOpportunity> & OpportunityPageState>,
  filterSet: OpportunityFilterSet,
) => {
  state.page = 1
  state.shouldFetchList = true
  state.filterSet = normalizeFilters<IOpportunity, OpportunityFilterSet>(
    filterSet,
  )
  setOrderBy(state, filterSet.orderBy)
}

export const applyClosedWonFilter = (normalizedFilters: string[]): string[] => {
  const statusesToCheck = Object.values(SOLD_SERVICE_STATUS).filter(
    (x) => x !== SOLD_SERVICE_STATUS.NotSent,
  )

  const hasSoldServiceStatusExclusion = statusesToCheck.every((status) =>
    normalizedFilters.some((f) =>
      f.includes(`soldServiceStatus ne '${status}'`),
    ),
  )

  return hasSoldServiceStatusExclusion
    ? [...normalizedFilters, '(closedWon eq false)']
    : normalizedFilters
}
